/*
  assets/gtender-dashboard.js — GTENDER-NATIVE-PRO-DASHBOARD-G15-01
  Owner: /pages/gtender-dashboard GTender Pro read-only cloud workspace projection.
  Identity authority: LittleGWebSession bearer -> Core native principal.
  Legacy workspace ownership remains isolated until explicit mapping or migration.
*/
(function () {
  'use strict';

  var VERSION = 'gtender-native-pro-dashboard-g15-01';
  var ROOT_SELECTOR = '[data-gtender-dashboard-root][data-native-session-required]';
  var GLOBAL_KEY = '__GTENDER_DASHBOARD_RUNTIME__';
  var API_BASE = 'https://api.glhksolution.com';
  var ENDPOINTS = Object.freeze({
    saved: API_BASE + '/v1/tender/saved',
    alerts: API_BASE + '/v1/tender/alerts',
    pipeline: API_BASE + '/v1/tender/pipeline'
  });
  var stateByRoot = new WeakMap();

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function list(root, selector) {
    return root && root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function isZh() {
    return /^zh(?:-|$)/i.test(String(document.documentElement.lang || navigator.language || ''));
  }

  function copy(zh, en) {
    return isZh() ? zh : en;
  }

  async function getJson(url, signal) {
    var session = window.LittleGWebSession;
    if (!session || typeof session.authenticatedFetch !== 'function') {
      return { ok: false, status: 0, data: {}, code: 'native_session_unavailable' };
    }
    try {
      var response = await session.authenticatedFetch(url, {
        method: 'GET',
        signal: signal,
        headers: { Accept: 'application/json' }
      });
      var payload = await response.json().catch(function () { return {}; });
      return {
        ok: response.ok && payload && payload.success !== false,
        status: response.status,
        code: payload && payload.error && payload.error.code || '',
        data: payload && payload.data && typeof payload.data === 'object' ? payload.data : {}
      };
    } catch (error) {
      return {
        ok: false,
        status: 0,
        code: error && error.name === 'AbortError' ? 'aborted' : 'network_error',
        data: {}
      };
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function setStat(root, name, value) {
    var node = root.querySelector('[data-gtender-dashboard-stat="' + name + '"]');
    if (node) node.textContent = value == null ? '—' : String(Number(value) || 0);
  }

  function tenderTitle(item) {
    var tender = item && item.tender && typeof item.tender === 'object' ? item.tender : item || {};
    return clean(tender.title || tender.subject_en || tender.subject_zh_hk || tender.tender_reference || tender.id)
      || copy('招標機會', 'Tender opportunity');
  }

  function buildRow(item, type, status) {
    var row = element('article', 'gtender-dashboard__row');
    row.appendChild(element('strong', '', tenderTitle(item)));
    var meta = element('div', 'gtender-dashboard__meta');
    meta.appendChild(element('span', '', type));
    meta.appendChild(element('span', '', status || copy('進行中', 'Active')));
    row.appendChild(meta);
    return row;
  }

  function renderList(root, saved, pipeline) {
    var container = root.querySelector('[data-gtender-dashboard-list]');
    if (!container) return;
    container.replaceChildren();

    var rows = [];
    (Array.isArray(pipeline) ? pipeline : []).slice(0, 5).forEach(function (item) {
      rows.push(buildRow(item, 'Pipeline', clean(item.stage) || copy('監察中', 'Watching')));
    });
    (Array.isArray(saved) ? saved : []).slice(0, Math.max(0, 8 - rows.length)).forEach(function (item) {
      rows.push(buildRow(item, copy('收藏', 'Saved'), clean(item.status || item.source_status) || copy('已收藏', 'Saved')));
    });

    if (!rows.length) {
      var empty = element('div', 'gtender-dashboard__empty');
      empty.appendChild(element('h3', '', copy('Pro 工作區目前沒有項目', 'No Pro workspace items yet')));
      empty.appendChild(element('p', '', copy('從 GTender 收藏招標，或把招標加入 Pipeline。', 'Save a tender or add it to your pipeline from GTender.')));
      var action = element('a', 'gtender-dashboard__button gtender-dashboard__button--primary', /^zh-CN$/i.test(clean(document.documentElement.lang)) ? '探索招标' : copy('探索招標', 'Explore tenders'));
      action.href = root.getAttribute('data-radar-url') || '/pages/gtender';
      empty.appendChild(action);
      container.appendChild(empty);
      return;
    }
    rows.forEach(function (row) { container.appendChild(row); });
  }

  function renderUnavailable(root, ownershipBlocked) {
    var container = root.querySelector('[data-gtender-dashboard-list]');
    if (!container) return;
    var unavailable = element('div', 'gtender-dashboard__empty');
    unavailable.appendChild(element('h3', '', ownershipBlocked
      ? copy('工作區資料尚未完成遷移', 'Workspace ownership migration is pending')
      : copy('工作區資料暫時無法載入', 'Workspace data is temporarily unavailable')));
    unavailable.appendChild(element('p', '', ownershipBlocked
      ? copy('舊工作區資料保留於原有帳戶，完成驗證及遷移後才會在此顯示。', 'Existing workspace records remain with their original owner until verified mapping or migration is complete.')
      : copy('請稍後再試；你的方案會由後端重新驗證。', 'Please try again later. Your plan is revalidated by the backend.')));
    container.replaceChildren(unavailable);
  }

  async function render(root, state) {
    if (!root || !root.isConnected || root.getAttribute('data-access-state') !== 'pro') return;
    state.sequence += 1;
    var sequence = state.sequence;
    if (state.requestController) state.requestController.abort();
    state.requestController = typeof AbortController === 'function' ? new AbortController() : null;
    var signal = state.requestController ? state.requestController.signal : undefined;
    root.setAttribute('data-dashboard-render-state', 'loading');

    var results = await Promise.all([
      getJson(ENDPOINTS.saved, signal),
      getJson(ENDPOINTS.alerts, signal),
      getJson(ENDPOINTS.pipeline, signal)
    ]);
    if (!state.active || sequence !== state.sequence || root.getAttribute('data-access-state') !== 'pro') return;

    if (results.some(function (result) { return result.status === 401 || result.status === 403; })) {
      setStat(root, 'saved', null);
      setStat(root, 'alerts', null);
      setStat(root, 'pipeline', null);
      var container = root.querySelector('[data-gtender-dashboard-list]');
      if (container) container.replaceChildren();
      root.setAttribute('data-dashboard-render-state', 'access-changed');
      root.dispatchEvent(new CustomEvent('gtender-dashboard:access-refresh-required', { bubbles: true }));
      return;
    }

    if (results.some(function (result) { return result.code === 'workspace_ownership_migration_required'; })) {
      setStat(root, 'saved', null);
      setStat(root, 'alerts', null);
      setStat(root, 'pipeline', null);
      renderUnavailable(root, true);
      root.setAttribute('data-dashboard-render-state', 'ownership-blocked');
      return;
    }

    var saved = Array.isArray(results[0].data.items) ? results[0].data.items : [];
    var alerts = Array.isArray(results[1].data.items) ? results[1].data.items : [];
    var pipeline = Array.isArray(results[2].data.items) ? results[2].data.items : [];
    setStat(root, 'saved', results[0].ok ? saved.length : null);
    setStat(root, 'alerts', results[1].ok ? alerts.length : null);
    setStat(root, 'pipeline', results[2].ok ? pipeline.length : null);

    if (results[0].ok && results[2].ok) renderList(root, saved, pipeline);
    else renderUnavailable(root);

    root.setAttribute(
      'data-dashboard-render-state',
      results.every(function (result) { return result.ok; }) ? 'ready' : 'partial'
    );
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var state = {
      active: true,
      sequence: 0,
      controller: new AbortController(),
      requestController: null
    };
    stateByRoot.set(root, state);
    root.setAttribute('data-dashboard-runtime-version', VERSION);
    root.addEventListener('gtender-dashboard:pro-ready', function () { render(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:access-invalidated', function () {
      state.sequence += 1;
      if (state.requestController) state.requestController.abort();
    }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:access-refresh-required', async function () {
      if (window.GTenderDashboardAccess && typeof window.GTenderDashboardAccess.refresh === 'function') {
        // Revalidate the mounted root once; persistent private denial must not
        // produce an automatic access -> private-read -> access retry loop.
        var refresh = window.GTenderDashboardAccess.refresh(root, { retryPrivateReads: false });
        var sequence = state.sequence;
        await refresh;
        if (sequence !== state.sequence) return;
      }
      if (!state.active || !root.isConnected) return;
      if (root.getAttribute('data-access-state') === 'pro') {
        renderUnavailable(root);
        root.setAttribute('data-dashboard-render-state', 'unavailable');
      }
    }, { signal: state.controller.signal });
    if (root.getAttribute('data-access-state') === 'pro') render(root, state);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    state.sequence += 1;
    if (state.requestController) state.requestController.abort();
    state.controller.abort();
    stateByRoot.delete(root);
    root.removeAttribute('data-dashboard-runtime-version');
    root.removeAttribute('data-dashboard-render-state');
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mount(target);
    list(target, ROOT_SELECTOR).forEach(mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
    list(target, ROOT_SELECTOR).forEach(destroy);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target || document); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });

  var api = Object.freeze({
    version: VERSION,
    boot: boot,
    destroy: destroyAll,
    render: function (root) {
      var state = stateByRoot.get(root);
      if (state) render(root, state);
    }
  });
  window[GLOBAL_KEY] = api;
  window.GTenderDashboard = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
})();
